import { useAuth } from "oidc-react";

export const useAppLogout = () => {
  const { userManager } = useAuth();

  const logout = async () => {
    try {
      const authUrl = import.meta.env.PUBLIC_AUTH_AUTHORITY;

      await userManager.removeUser();
      sessionStorage.clear();
      localStorage.clear();

      window.location.href = `${authUrl}connect/endsession?post_logout_redirect_uri=${encodeURIComponent(
        import.meta.env.PUBLIC_MAIN_URL
      )}`;
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return logout;
};
